<template>
  <v-row class="ma-0" id="dashCalor" :class="$vuetify.theme.dark ? 'dash_dark_bg' : 'dash_white_bg'" style="position: relative;
    z-index: 1;">
    <v-col cols="12" sm="12" md="12" class="py-0">
      <div class="ui-white-card" v-if="!loading">
        <div class="text-h3 text-center text-primary mb-3 mt-2">Mapa de Usinas</div>
        <v-card class="text-center mt-1" height="507px" flat :key="keyMapa">
          <v-card-text justify="center" align="center" class="pa-0 fill-height">
            <div id="map-wrap" style="height: 100%; width: 100%">
              <l-map :zoom="4" :center="[-15.46987544246151, -55.21277073511001]">
                <l-tile-layer
                  :url="$vuetify.theme.dark ? 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png' : 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_labels_under/{z}/{x}/{y}.png'"
                ></l-tile-layer>
                <l-layer-group layerType="overlay" name="Sources">
                  <v-marker-cluster :options="clusterOptions3">
                    <l-marker
                      v-for="(item, index) in marcadores"
                      :key="index"
                      :visible="item.status.uss_nome  === 'Online' ? online : item.status.uss_nome  === 'Offline' ? offline : item.status.uss_nome  === 'Alerta' ? alerta : item.status.uss_nome  === 'Não definido' ? naoDefinido : item.status.uss_nome  === 'Sem conexão' ? semConexao : item.status.uss_nome  === 'Sem retorno' ? semRetorno : naoDefinido"
                      :lat-lng="[returnlatLong(item.usi_latitude, 'lat'), returnlatLong(item.usi_longitude, 'long')]"
                      :icon=" item.status.uss_nome  === 'Online' ? onlineIcon : item.status.uss_nome  === 'Offline' ? offlineIcon : item.status.uss_nome  === 'Alerta' ? alertaIcon : item.status.uss_nome  === 'Não definido' ? naoDefinidoIcon : item.status.uss_nome  === 'Sem conexão' ? semConexaoIcon : item.status.uss_nome  === 'Sem retorno' ? semRetornoIcon : naoDefinidoIcon"
                    >
                      <l-popup>
                        <v-row>
                          <v-col cols="12" class="pb-0">
                            <a target="_blank" :href="'/visao-geral/' + item.uuid_usi_id">#{{item.usi_id}}</a> - {{item.usi_desativado_em ? item.usi_nome + ' - Desativada' : item.usi_nome}}
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" class="pb-0">
                            <span v-if="item.cliente"><b>Cliente:</b> {{ item.cliente.cli_nome }}</span>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="9" class="pb-0">
                            <span v-if="item.projeto">
                              <b>PV Capacidade:</b> {{item.projeto.usp_potencia.replace('.', ',')}} kWp
                            </span>
                          </v-col>
                          <v-col cols="3" class="pb-0" v-if="item.inversores.length === 1">
                              <img
                                width="25"
                                :src="getSrcImg(item.inversores[0])"
                                :alt="item.inversores[0].inversor.inv_marca"
                                :title="item.inversores[0].inversor.inv_marca"
                                v-b-tooltip.hover
                              >
                          </v-col>
                        </v-row>
                        <v-row v-if="item.inversores.length > 1">
                          <v-col cols="3" v-for="(inversor, i) in item.inversores" :key="i">
                              <img
                                width="25"
                                :src="getSrcImg(inversor)"
                                :alt="inversor.inversor.inv_marca"
                                :title="inversor.inversor.inv_marca"
                                v-b-tooltip.hover
                              >
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col cols="auto">
                            <span v-if="item.integrador && item.integrador.int_imagem">
                              <img :alt="item.integrador.int_nome" :src="item.integrador.int_imagem" width="50" height="50">
                            </span>
                          </v-col>
                        </v-row>
                      </l-popup>
                    </l-marker>
                  </v-marker-cluster>
                </l-layer-group>
                <l-control position="bottomleft">
                  <div class="legenda_mapa w-100 text-left" style="cursor: pointer; background-color: rgb(0, 0, 0, 0.2); border-radius: 7px; padding: 5px">
                    <div class="linha grey--text text--darken-2" @click="online = !online">
                      <v-row no-gutters>
                        <div v-if="online" class="box_cor pull-left" style="background-color: #118F2D;"></div>
                        <div v-if="!online" class="box_cor pull-left" style="background-color: grey;"></div>
                        Online
                      </v-row>
                    </div>
                    <div class="linha grey--text text--darken-2" @click="offline = !offline">
                      <v-row no-gutters>
                        <div v-if="offline" class="box_cor pull-left" style="background-color:#FF0B0B;"></div>
                        <div v-if="!offline" class="box_cor pull-left" style="background-color: grey;"></div>
                        Offline
                      </v-row>
                    </div>
                    <div class="linha grey--text text--darken-2" @click="alerta = !alerta">
                      <v-row no-gutters>
                        <div v-if="alerta" class="box_cor pull-left" style="background-color:#EC6521;"></div>
                        <div v-if="!alerta" class="box_cor pull-left" style="background-color: grey;"></div>
                        Alerta
                      </v-row>
                    </div>
                    <div class="linha grey--text text--darken-2" @click="naoDefinido = !naoDefinido">
                      <v-row no-gutters>
                        <div v-if="naoDefinido" class="box_cor pull-left" style="background-color: #F8B518;"></div>
                        <div v-if="!naoDefinido" class="box_cor pull-left" style="background-color: grey;"></div>
                        Não definido
                      </v-row>
                    </div>
                    <div class="linha grey--text text--darken-2" @click="semConexao = !semConexao">
                      <v-row no-gutters>
                        <div v-if="semConexao" class="box_cor pull-left" style="background-color: #4393B6;"></div>
                        <div v-if="!semConexao" class="box_cor pull-left" style="background-color: grey;"></div>
                        Sem conexão
                      </v-row>
                    </div>
                    <div class="linha grey--text text--darken-2" @click="semRetorno = !semRetorno">
                      <v-row no-gutters>
                        <div v-if="semRetorno" class="box_cor pull-left" style="background-color: #8A8A8A;"></div>
                        <div v-if="!semRetorno" class="box_cor pull-left" style="background-color: grey;"></div>
                        Sem retorno
                      </v-row>
                    </div>
                  </div>
                </l-control>
              </l-map>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="ui-dialog-content" v-else>
       <v-skeleton-loader type="image, image"></v-skeleton-loader>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import L from 'leaflet'
export default {
  props: ['localizations'],
  components: {
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  data () {
    return {
      loading: false,
      offline: true,
      naoDefinido: true,
      semConexao: true,
      semRetorno: true,
      online: true,
      alerta: true,
      marcadores: this.localizations,
      clusterOptions: {
        iconCreateFunction: cluster => {
          var childCount = cluster.getChildCount()
          var c = ' marker-cluster-'
          if (childCount < 10) {
            c += 'small'
          } else if (childCount < 100) {
            c += 'medium'
          } else {
            c += 'large'
          }
          return new L.DivIcon({
            html:
              '<div class="black--text font-weight-bold subtitle-1" style="background-color: #fdd835; display: flex!important;flex-direction: column;align-content: center;justify-content: center;"><span> ' +
              childCount +
              '</span></div>',
            className: 'marker-cluster background-cluster-yellow' + c,
            iconSize: new L.Point(40, 40)
          })
        }
      },
      clusterOptions2: {
        iconCreateFunction: cluster => {
          var childCount = cluster.getChildCount()
          var c = ' marker-cluster-'
          if (childCount < 10) {
            c += 'small'
          } else if (childCount < 100) {
            c += 'medium'
          } else {
            c += 'large'
          }
          return new L.DivIcon({
            html:
              '<div class="black--text font-weight-bold subtitle-1" style="background-color: #c90e0e; display: flex!important;flex-direction: column;align-content: center;justify-content: center;"><span> ' +
              childCount +
              '</span></div>',
            className: 'marker-cluster background-cluster-red' + c,
            iconSize: new L.Point(40, 40)
          })
        }
      },
      clusterOptions3: {
        iconCreateFunction: cluster => {
          var childCount = cluster.getChildCount()
          var c = ' marker-cluster-'
          if (childCount < 10) {
            c += 'small'
          } else if (childCount < 100) {
            c += 'medium'
          } else {
            c += 'large'
          }
          return new L.DivIcon({
            html:
              '<div class="black--text font-weight-bold subtitle-1" style="background-color: #3ec90eab; display: flex!important;flex-direction: column;align-content: center;justify-content: center;"><span> ' +
              childCount +
              '</span></div>',
            className: 'marker-cluster background-cluster-green' + c,
            iconSize: new L.Point(40, 40)
          })
        }
      },
      clusterOptions4: {
        iconCreateFunction: cluster => {
          var childCount = cluster.getChildCount()
          var c = ' marker-cluster-'
          if (childCount < 10) {
            c += 'small'
          } else if (childCount < 100) {
            c += 'medium'
          } else {
            c += 'large'
          }
          return new L.DivIcon({
            html:
              '<div class="black--text font-weight-bold subtitle-1" style="background-color: #3ec90eab; display: flex!important;flex-direction: column;align-content: center;justify-content: center;"><span> ' +
              childCount +
              '</span></div>',
            className: 'marker-cluster background-cluster-green' + c,
            iconSize: new L.Point(40, 40)
          })
        }
      },
      keyMapa: 0,
      onlineIcon: L.icon({
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        iconUrl: require('@assets/img/markers/online.png'),
        shadowAnchor: [0, 0],
        iconAnchor: [13, 13],
        shadowSize: [0, 0],
        iconSize: [26, 42]
      }),
      offlineIcon: L.icon({
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        iconUrl: require('@assets/img/markers/offline.png'),
        shadowAnchor: [0, 0],
        iconAnchor: [13, 13],
        shadowSize: [0, 0],
        iconSize: [26, 42]
      }),
      alertaIcon: L.icon({
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        iconUrl: require('@assets/img/markers/alerta.png'),
        shadowAnchor: [0, 0],
        iconAnchor: [13, 13],
        shadowSize: [0, 0],
        iconSize: [26, 42]
      }),
      naoDefinidoIcon: L.icon({
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        iconUrl: require('@assets/img/markers/nao-definido.png'),
        shadowAnchor: [0, 0],
        iconAnchor: [13, 13],
        shadowSize: [0, 0],
        iconSize: [26, 42]
      }),
      semConexaoIcon: L.icon({
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        iconUrl: require('@assets/img/markers/sem-conexao.png'),
        shadowAnchor: [0, 0],
        iconAnchor: [13, 13],
        shadowSize: [0, 0],
        iconSize: [26, 42]
      }),
      semRetornoIcon: L.icon({
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        iconUrl: require('@assets/img/markers/sem-retorno.png'),
        shadowAnchor: [0, 0],
        iconAnchor: [13, 13],
        shadowSize: [0, 0],
        iconSize: [26, 42]
      })
      // defaultIcon: L.icon({
      //   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      //   iconUrl: require('leaflet/dist/images/marker-icon.png'),
      //   shadowAnchor: [0, 0],
      //   iconAnchor: [13, 13],
      //   shadowSize: [0, 0],
      //   iconSize: [26, 42]
      // })
      // greenIcon: L.icon({
      //   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      //   iconUrl: require('@assets/img/marker-icon-2x-green.png'),
      //   shadowAnchor: [0, 0],
      //   iconAnchor: [13, 13],
      //   shadowSize: [0, 0],
      //   iconSize: [26, 42]
      // }),
      // redIcon: L.icon({
      //   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      //   iconUrl: require('@assets/img/marker-icon-2x-red.png'),
      //   shadowAnchor: [0, 0],
      //   iconAnchor: [13, 13],
      //   shadowSize: [0, 0],
      //   iconSize: [26, 42]
      // }),
      // goldIcon: L.icon({
      //   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      //   iconUrl: require('@assets/img/marker-icon-2x-gold.png'),
      //   shadowAnchor: [0, 0],
      //   iconAnchor: [13, 13],
      //   shadowSize: [0, 0],
      //   iconSize: [26, 42]
      // })
    }
  },
  created () {
    this.getMapaCalor()
  },
  methods: {
    returnlatLong (input, latOuLong) {
      if (input) {
        if (input.match('°') || input.match('′') || input.match('″')) {
          var parts = input.split(/[^\d\w]+/)
          if (latOuLong === 'lat') {
            return this.convertDMSToDD(parts[1], parts[2], parts[3], parts[4])
          } else {
            return this.convertDMSToDD(parts[1], parts[2], parts[3], parts[4])
          }
        } else {
          return input
        }
      } else {
        return ''
      }
    },
    convertDMSToDD (degrees, minutes, seconds, direction) {
      var dd = Number(degrees) + Number(minutes) / 60 + Number(seconds) / (60 * 60)
      if (direction === 'S' || direction === 'W') {
        dd = dd * -1
      }
      return dd
    },
    getSrcImg (inversor) {
      const baseUrl = window.location.origin
      // const baseUrl = 'http://localhost/storage'
      return `${baseUrl}/storage/fabricante/${inversor.inversor.inv_marca.toLowerCase()}.png`
    },
    async getMapaCalor () {
      this.loading = true
      this.keyMapa++
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@scss/_variables.scss';
@import '@scss/_ui.scss';
</style>



// WEBPACK FOOTER //
// src/components/graficos/MapaCalor.vue